export default "__VITE_ASSET__$ICG4DRT__"